import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LocalstorageService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { SchoolselectorService } from "../schoolselectorservice.service";

@Component({
	selector: "caass-schoolselector",
	templateUrl: "./schoolselector.component.html",
	styleUrls: ["./schoolselector.component.css"],
})
export class SchoolselectorComponent implements OnInit {
	constructor(
		private localService: LocalstorageService,
		private schoolService: SchoolService,
		private selectService: SchoolselectorService,
		private personService: PersonSelectorService
	) {}

	ngOnInit(): void {
		// var cks = document.cookie;
		// console.log(cks);

		if (this.OverrideSchools == false) {
			this.loadSchoolist();
		} else if (this.OverrideSchools == true && this.lstSchool.length > 0) {
			this.loadOverride();
		}

		this.RefreshSubscription = this.selectService.onRefreshChanged().subscribe((val) => {
			if (String(val).toLowerCase() == "refresh") {
				this.loadErrors();
			}
		});
	}

	ngOnChanges() {
		if (this.OverrideSchools == true && this.lstSchool.length > 0) {
			this.loadOverride();
		}
	}

	ngOnDestroy() {
		this.RefreshSubscription.unsubscribe();
	}

	/////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////

	RefreshSubscription: any;

	LOCAL_KEY = "SchoolSelector_School";

	////////////////////////////////
	//Input Options
	////////////////////////////////

	//
	//School Options
	//
	@Input() ShowAll: any = true; //Add Show All Schools option to the beginning of the list
	@Input() ShowAllText: any = "All"; //Text for the show all item (Usually All, District, any, etc.)
	@Input() ShowAllID: any = -1; //ID of Show all item (Usually -1 or 0)

	@Input() lstExtraOptions: any = []; //List of items to add the beginning of the list (ex. ID: -2, Desc: Only Active Schools)
	//Example Entry:
	// {
	//   SchoolID: -2,
	//   SchoolNumber: "-2",
	//   SchoolName: "Only Active Schools",
	//   SchoolFullName: "Only Active Schools"
	// }

	//
	//Page Options
	//
	@Input() IsReport: any = false;
	@Input() ApplicationItemID: any = ""; //Which page to get schools for
	@Input() ReportID: any = 0; //Reports call their own method to see what schools the user has access to for that page

	//
	// Disable
	//
	@Input() Disabled: any = false;

	////////////////////////////////

	SchoolLoading: any = true;
	SelectedSchool: any;
	@Input() OverrideSchools: any = false;
	@Input() lstSchool: any = []; //Allow Users to manually override
	@Input() TableTypeID: number = -1;

	SortType: any = "Name"; //Name or Number
	SortDirection: any = "ASC"; //Asc or Desc

	/////////////////////////////////////////////

	/////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////
	loadSchoolist() {
		this.SchoolLoading = true;

		var result: any;
		if (this.IsReport == false) {
			result = this.schoolService.loadSchoolListWithOptions(this.ApplicationItemID, this.TableTypeID);
		} else {
			result = this.schoolService.GetSchoolsForUserReport(this.ReportID);
		}

		result.subscribe(
			(response: any) => {
				this.lstSchool = response;

				//
				// Order:
				// All Schools (w/ Custom text/ID)
				// Extra options in original order
				// Schools that the user has access to
				//
				if (this.lstExtraOptions.length > 0) {
					var lstOpt = Array.from(this.lstExtraOptions).reverse(); //Unshift, so LIFO order like stack

					for (var z = 0; z < lstOpt.length; z++) {
						var next = lstOpt[z];

						this.lstSchool.unshift(next);
					}
				}

				if (this.ShowAll == true) {
					this.lstSchool.unshift({
						SchoolID: this.ShowAllID,
						SchoolNumber: String(this.ShowAllID),
						SchoolName: this.ShowAllText,
						SchoolFullName: this.ShowAllText,
						WarningLevelID: 0,
					});
				}

				//
				// Check if a school was already selected
				//

				var SchoolFromService = this.localService.getItem(this.LOCAL_KEY); //this.selectService.SchoolChangeSubject.value;

				// console.log("Load School List");
				// console.log("School From Service");
				// console.log(SchoolFromService);

				if (SchoolFromService != undefined && SchoolFromService != "") {
					//
					// Check if school is in the list (Permissions might vary from page to page)
					//

					var found = false;

					for (var i = 0; i < this.lstSchool.length; i++) {
						var s = this.lstSchool[i];

						if (s.SchoolID == SchoolFromService.SchoolID) {
							this.SelectedSchool = s;

							found = true;
							break;
						}
					}

					//
					// Not in list, select the first entry
					//

					if (!found) {
						this.onSchoolChange(this.lstSchool[0]);
					} else {
						this.onSchoolChange(this.SelectedSchool);
					}
				} else {
					this.onSchoolChange(this.lstSchool[0]);
				}

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	loadOverride() {
		this.SchoolLoading = true;

		//
		// Order:
		// All Schools (w/ Custom text/ID)
		// Extra options in original order
		// Schools that the user has access to
		//
		if (this.lstExtraOptions.length > 0) {
			var lstOpt = Array.from(this.lstExtraOptions).reverse(); //Unshift, so LIFO order like stack

			for (var z = 0; z < lstOpt.length; z++) {
				var next = lstOpt[z];

				this.lstSchool.unshift(next);
			}
		}

		if (this.ShowAll == true) {
			this.lstSchool.unshift({
				SchoolID: this.ShowAllID,
				SchoolNumber: String(this.ShowAllID),
				SchoolName: this.ShowAllText,
				SchoolFullName: this.ShowAllText,
				WarningLevelID: 0,
			});
		}

		//
		// Check if a school was already selected
		//

		var SchoolFromService = this.selectService.SchoolChangeSubject.value;

		// console.log("Load Override");
		// console.log("School From Service");
		// console.log(SchoolFromService);

		if (SchoolFromService != "") {
			//
			// Check if school is in the list (Permissions might vary from page to page)
			//

			var found = false;

			for (var i = 0; i < this.lstSchool.length; i++) {
				var s = this.lstSchool[i];

				if (s.SchoolID == SchoolFromService.SchoolID) {
					this.SelectedSchool = SchoolFromService;
					found = true;
					break;
				}
			}

			//
			// Not in list, select the first entry
			//

			if (!found) {
				this.onSchoolChange(this.lstSchool[0]);
			} else {
				this.onSchoolChange(SchoolFromService);
			}
		} else {
			this.onSchoolChange(this.lstSchool[0]);
		}

		this.SchoolLoading = false;
	}

	//
	// Refresh loading schools with warning levels (For Top 5 Validation)
	// Don't change current school, just reload warning levels and resort
	//
	loadErrors() {
		this.SchoolLoading = true;

		// console.log("Load Errors");
		// console.log(this.SelectedSchool);

		var result: any;
		result = this.schoolService.loadSchoolListWithOptions(this.ApplicationItemID, this.TableTypeID);
		result.subscribe(
			(response: any) => {
				var NewData = response;

				//
				// Get New Warning Level
				//
				var NewWarningLevel = this.SelectedSchool.WarningLevelID;

				for (var z = 0; z < NewData.length; z++) {
					var nextNewSchool = NewData[z];

					if (nextNewSchool.SchoolID == this.SelectedSchool.SchoolID) {
						// console.log("Current School Found");
						// console.log(nextNewSchool);
						NewWarningLevel = nextNewSchool.WarningLevelID;
						break;
					}
				}

				// console.log("New Warning Level");
				// console.log(NewWarningLevel);

				//
				// Update Warning Level
				//
				for (var z = 0; z < this.lstSchool.length; z++) {
					var nextOldSchool = this.lstSchool[z];

					if (nextOldSchool.SchoolID == this.SelectedSchool.SchoolID) {
						// console.log("Old School Found");
						// console.log(nextOldSchool);

						nextOldSchool.WarningLevelID = NewWarningLevel;
						this.SelectedSchool.WarningLevelID = NewWarningLevel;
					}
				}

				//
				// Resort Schools
				//
				this.SortSchools();

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	/////////////////////////////////////////////

	/////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////
	onToggleSortType() {
		if (String(this.SortType) == "Name") {
			this.SortType = "Number";
		} else if (String(this.SortType) == "Number") {
			this.SortType = "Name";
		}

		this.SortSchools();
	}

	onToggleSortDirection() {
		if (String(this.SortDirection) == "ASC") {
			this.SortDirection = "DESC";
		} else if (String(this.SortDirection) == "DESC") {
			this.SortDirection = "ASC";
		}

		this.SortSchools();
	}

	SortSchools() {
		var SelectFirst = false; //Don't Change Current Entry to first in list

		if (this.SortType == "Name") {
			if (this.SortDirection == "ASC") {
				this.SortAscName(SelectFirst);
			} else if (this.SortDirection == "DESC") {
				this.SortDescName(SelectFirst);
			}
		} else if (this.SortType == "Number") {
			if (this.SortDirection == "ASC") {
				this.SortAscNumber(SelectFirst);
			} else if (this.SortDirection == "DESC") {
				this.SortDescNumber(SelectFirst);
			}
		}
	}

	SortAscName(SelectFirst) {
		this.lstSchool = Array.from(this.lstSchool).sort((a: any, b: any) => {
			//
			// Check Warning Level First
			//
			if (a.WarningLevelID < b.WarningLevelID) {
				return 1;
			} else if (a.WarningLevelID > b.WarningLevelID) {
				return -1;
			}
			//
			// If same, do normal check
			//
			else {
				if (String(a.SchoolName) < String(b.SchoolName)) {
					return -1;
				} else if (String(a.SchoolName) > String(b.SchoolName)) {
					return 1;
				} else {
					return 0;
				}
			}
		});

		if (SelectFirst == true) {
			this.onSchoolChange(this.lstSchool[0]);
		}
	}

	SortDescName(SelectFirst) {
		this.lstSchool = Array.from(this.lstSchool).sort((a: any, b: any) => {
			//
			// Check Warning Level First
			//
			if (a.WarningLevelID < b.WarningLevelID) {
				return 1;
			} else if (a.WarningLevelID > b.WarningLevelID) {
				return -1;
			} else {
				if (String(a.SchoolName) < String(b.SchoolName)) {
					return 1;
				} else if (String(a.SchoolName) > String(b.SchoolName)) {
					return -1;
				} else {
					return 0;
				}
			}
		});

		if (SelectFirst == true) {
			this.onSchoolChange(this.lstSchool[0]);
		}
	}

	SortAscNumber(SelectFirst) {
		this.lstSchool = Array.from(this.lstSchool).sort((a: any, b: any) => {
			//
			// Check Warning Level First
			//
			if (a.WarningLevelID < b.WarningLevelID) {
				return 1;
			} else if (a.WarningLevelID > b.WarningLevelID) {
				return -1;
			} else {
				if (String(a.SchoolNumber) < String(b.SchoolNumber)) {
					return -1;
				} else if (String(a.SchoolNumber) > String(b.SchoolNumber)) {
					return 1;
				} else {
					return 0;
				}
			}
		});

		if (SelectFirst == true) {
			this.onSchoolChange(this.lstSchool[0]);
		}
	}
	SortDescNumber(SelectFirst) {
		this.lstSchool = Array.from(this.lstSchool).sort((a: any, b: any) => {
			//
			// Check Warning Level First
			//
			if (a.WarningLevelID < b.WarningLevelID) {
				return 1;
			} else if (a.WarningLevelID > b.WarningLevelID) {
				return -1;
			} else {
				if (String(a.SchoolNumber) < String(b.SchoolNumber)) {
					return 1;
				} else if (String(a.SchoolNumber) > String(b.SchoolNumber)) {
					return -1;
				} else {
					return 0;
				}
			}
		});
		if (SelectFirst == true) {
			this.onSchoolChange(this.lstSchool[0]);
		}
	}

	/////////////////////////////////////////////

	/////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		//
		// Call Service to update
		//
		this.selectService.SchoolChanged(this.SelectedSchool);
		this.localService.setItem(this.LOCAL_KEY, this.SelectedSchool);

		this.personService.ManuallyChangeSchool(this.SelectedSchool);
	}

	/////////////////////////////////////////////

	/////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////

	IsDisabled() {
		return this.SchoolLoading == true || this.Disabled == true;
	}

	/////////////////////////////////////////////
}
